module.exports = __webpack_public_path__ + "e182a596570cd86831837d726f36edfb.MP3";